module.exports = __webpack_public_path__ + "static/media/down.fc3f6865.svg";